<template>
<!-- eslint-disable max-len -->
<edit-page
  name="Support Category"
  model-name="articleCategory"
  param="articleCategoryId"
  page-prefix="/blade/article-categories"
  :create="createArticleCategory"
  :fetch="getArticleCategory"
  :fetch-types="getArticleCategoryTypes"
  :update="updateArticleCategory"
  :remove="deleteArticleCategory"
  :enum-names="['articleCategories']"
  :stub="articleCategory"
  :validator="validator"
  :utils="utils">
<template slot-scope="{ model: articleCategory, enums: { articleCategories }, validator }">
  <text-input label v-model="articleCategory.title" :validator="validator.title" required autofocus>Title</text-input>

  <text-input label v-model="articleCategory.description">Description</text-input>

  <select-input
    label
    v-model="articleCategory.category"
    :options="articleCategories"
    use="_id"
    display="title"
    :to="(id) => { return `/blade/article-categories/${id}/edit`; }"
  >
    Category
  </select-input>
</template>
</edit-page>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import EditPage from '../../ui/pages/EditPage';

import SelectInput from '../../ui/inputs/SelectInput';
import TextInput from '../../ui/inputs/TextInput';

export default {
  components: {
    EditPage,
    SelectInput,
    TextInput
  },
  data() {
    return {
      utils: {
      },
      articleCategory: {
        _id: '',
        title: '',
        description: '',
        category: null,
      },
      validator: {
        title: { required },
      },
    };
  },
  methods: {
    ...mapActions([
      'getArticleCategory',
      'getArticleCategoryTypes',
      'createArticleCategory',
      'updateArticleCategory',
      'deleteArticleCategory',
    ])
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/blade/pages/ArticleCategoryEdit.vue